// extracted by mini-css-extract-plugin
export default {"exerciseItem":"Exercise_exerciseItem__QC4VH","textPreview":"Exercise_textPreview__PQ7qD"};